import React from "react";

export default function SubmissionSuccessContent() {
  return (
    <div className="px-0 lg:px-12">
      <p className="text-green-600 px-5 lg:px-10">
        In the meantime, you can already invest up to P50,000 in a recommended
        fund!
      </p>
      <p>
        For any concerns regarding your application, email us at{" "}
        <a href="mailto:online@rampver.com" className="text-blue-600">
          online@rampver.com
        </a>
      </p>
    </div>
  );
}
